import { NotificationData } from "../models/notification.model";
import ServiceBase from "./base.service";

export class NotificationsService extends ServiceBase {
  countUnread = async (): Promise<number> =>
    await this.get<number>("notifications/unread/count");

  getAll = async (): Promise<NotificationData[]> =>
    this.get<NotificationData[]>("notifications");

  markAllRead = async (): Promise<void> => {
    await this.put<void>("notifications/read");
  };

  markRead = async (notificationId: number): Promise<void> => {
    await this.put<void>(`notifications/${notificationId}/read`);
  };

  deleteAllRead = async (): Promise<void> => {
    await this.delete("notifications");
  };

  remove = async (notificationId: number): Promise<void> => {
    await this.delete(`notifications/${notificationId}`);
  };
}

const notificationsService = new NotificationsService();

export default notificationsService;
